export default __webpack_public_path__ + "static/media/group-3-copy-2@2x.c2a876cc.png";